import {useState} from 'react';
import PropTypes from 'prop-types';

import UploadFile from '../../../../notification/UploadFile';
import NotificationView from './NotificationView';

function NotificationContainer({notification}) {
  const [isPanelOpen, setIsUploadPanelOpen] = useState(false);

  return (
    <>
      <NotificationView
        notification={notification}
        onUpload={() => setIsUploadPanelOpen(true)}
      />
      {isPanelOpen &&
        <UploadFile
          onClose={() => setIsUploadPanelOpen(false)}
          notificationId={notification.notificationId}
          documentName={notification.documentAtDate.documentName}
        />
      }
    </>
  );
}

NotificationContainer.propTypes = {
  notification: PropTypes.object.isRequired
};

export default NotificationContainer;
